<template>
  <div class="testimonials container-fluid p-b-6" id="testimonials">
    <!--Section: Testimonials v.3-->
    <section class="section team-section">

      <!--Section heading-->
      <h1 class="section-heading">{{t('What others are saying')}}</h1>
      <!--First row-->
      <div class="row text-xs-center sameHeight">

        <Card class="card">
          <div slot="content">
            <div class="videoContainer image" style="padding-bottom: 65%">
              <iframe src="https://www.youtube.com/embed/uinHxDRBfGI?rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
          </div>
        </Card>
        <Card class="card">
          <div slot="title">
            <img class="" width="150" src="/static/img/logo-uniplanet.png" alt="Uniplanet">
          </div>
          <div slot="content">
            <p>({{t('Interview')}})</p>
            <p>"{{t('Booknatura is a new booking platform for outdoor activities that provide the contact with nature in Portugal')}}".</p>
            <p><a href="https://www.theuniplanet.com/2018/06/todas-atividades-ar-livre-portugal-booknatura.html" target="_blank">theuniplanet.com/2018/06/todas...</a></p>
          </div>
        </Card>
        <Card class="card">
          <div slot="title">
            <img class="" width="70" src="/static/img/logo-nit-cat-out-of-town.png" alt="logo nit">
          </div>
          <div slot="content">
            <p>
            "{{t('From jeep tours to scuba diving and dolphin watching: on this new platform you can book everything')}}."
            "De passeios de jipe a fazer mergulho e ver golfinhos: nesta nova plataforma pode reservar tudo."
            </p>
            <p><a href="https://nit.pt/out-of-town/se-gosta-de-atividades-ao-ar-livre-tem-de-conhecer-esta-nova-plataforma-online" target="_blank">nit.pt/out-of-town/se-gosta-de-ativid...</a></p>
          </div>
        </Card>
        <Card class="card">
          <div slot="title">Blog Uma Susana no Mundo</div>
          <div slot="content">
            <p>
            "{{t('Use booknatura.com to find out more about outdoor activities for yourself, friends and family')}}."
            </p>
            <p><a href="https://umasusananomundo.wordpress.com/2018/06/22/booknatura-com/" target="_blank">umasusananomundo.wordpress.com/...</a></p>
          </div>
        </Card>

        <Card>
          <div slot="title">
            Elsa M.
          </div>
          <div slot="content">
            "{{t('I did with my husband the Horse Carriage Tour in Alentejo Coast. In addition to the bamboos we had the opportunity to stroll along a stream in a typical Alentejo landscape. Very beautiful landscapes and very friendly and accessible guide. I recommend the tour and the Booknatura service')}}."
          </div>
        </Card>

        <Card>
          <div slot="title">
            Joana P.
          </div>
          <div slot="content">
            "{{t('Booknatura was a nice surprise! Practical, fast, easy and very efficient. I advise everyone who enjoys this type of activities to book through Booknatura. It was a great experience, to repeat!')}}."
          </div>
        </Card>
      </div>

    </section>
    <!--/Section: Testimonials v.3-->
  </div>
</template>

<script>
import Card from '../Card';

const testimonials = [];

export default {
  name: 'Testimonials',
  components: {
    Card,
  },
  data() {
    return {
      testimonials,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables-b4"; /* for $brand-primary */

.sameHeight {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  justify-content: center;
}
.card {
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 30px;
  width: 100%;
}

@media only screen and (min-width: map-get($grid-breakpoints, md)) {
  .card {
    width: calc(50% - 30px);
  }
}

@media only screen and (min-width: map-get($grid-breakpoints, lg)) {
  .card {
    width: calc(100% / 3 - 30px);
  }
}
/*@media only screen and (min-width: map-get($grid-breakpoints, xl)) {
  .card {
    width: calc(100% / 4 - 30px);
  }
}*/

.rounded-circle {
  border-radius: 50%;
}
img {
  box-shadow: 0 !important;
}

.videoContainer {
  position:relative;
  padding-top:30px;
  height:0;
  overflow:hidden;
  margin-bottom: 15px;
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
}

.videoContainer iframe, .videoContainer object, .videoContainer embed {
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
}
.logoUniplanet {
  width: 100%;
  padding: 15px;
}
.card p {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// Testimonials.vue?8bd94ca0